/* eslint-disable import/no-anonymous-default-export */

import { docodeHexResponse } from '../../_common/common.utils';
import ENACHUmrnUplaodActionTypes from './nach-umrn-link.type';

const INITIAL_STATE = {
	fetchENACHDetailsResponse: null,
	fetchENACHDetailsArr: [],
	fetchENACHUmrnUploadResponse: null,
	fetchENACHPaymentUploadResponse: null,
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		case ENACHUmrnUplaodActionTypes.FETCH_ENACH_EXPORT_DETAILS_SUCCESS:
			return {
				...state,
				fetchENACHDetailsResponse: action.payload,
				fetchENACHDetailsArr: docodeHexResponse(
					action.payload,
					'GetEnachApplicationDetailsListkey',
				),
			};

		case ENACHUmrnUplaodActionTypes.FETCH_ENACH_EXPORT_DETAILS_FAILURE:
			return { ...state, fetchENACHDetailsResponse: action.payload };

		case ENACHUmrnUplaodActionTypes.FETCH_ENACH_EXPORT_DETAILS_RESPONSE_CHANGED:
			return {
				...state,
				fetchENACHDetailsResponse: null,
			};

		case ENACHUmrnUplaodActionTypes.FETCH_ENACH_UMRN_UPLOAD_SUCCESS:
			return {
				...state,
				fetchENACHUmrnUploadResponse: action.payload,
			};

		case ENACHUmrnUplaodActionTypes.FETCH_ENACH_UMRN_UPLOAD_FAILURE:
			return { ...state, fetchENACHUmrnUploadResponse: action.payload };

		case ENACHUmrnUplaodActionTypes.FETCH_ENACH_UMRN_UPLOAD_RESPONSE_CHANGED:
			return {
				...state,
				fetchENACHUmrnUploadResponse: null,
			};

		case ENACHUmrnUplaodActionTypes.FETCH_ENACH_PAYMENT_UPLOAD_SUCCESS:
			return {
				...state,
				fetchENACHPaymentUploadResponse: action.payload,
			};

		case ENACHUmrnUplaodActionTypes.FETCH_ENACH_PAYMENT_UPLOAD_FAILURE:
			return { ...state, fetchENACHPaymentUploadResponse: action.payload };

		case ENACHUmrnUplaodActionTypes.FETCH_ENACH_PAYMENT_UPLOAD_RESPONSE_CHANGED:
			return {
				...state,
				fetchENACHPaymentUploadResponse: null,
			};

		default:
			return state;
	}
};
